import { IScope } from "angular";
import { AuthenticationResolverService } from "@gtmhub/auth";
import { LastUrlService } from "@gtmhub/util/last-url-service";

interface IAccountLinkedScope extends IScope {
  logout(): void;
}

export class AccountLinkedCtrl {
  public static $inject = ["$scope", "AuthenticationResolverService", "LastUrlService"];

  constructor(private $scope: IAccountLinkedScope, private authenticationResolverService: AuthenticationResolverService, private lastUrlService: LastUrlService) {
    this.$scope.logout = this.logout;

    this.updateLocationSearchToNavigateAfterSecondLogin();
  }

  private updateLocationSearchToNavigateAfterSecondLogin = (): void => {
    const storedLocationSearch = this.lastUrlService.getStoredLocationSearch() || {};
    storedLocationSearch[this.lastUrlService.keepLocationKey] = true;
    this.lastUrlService.storeCurrentLocationSearch(storedLocationSearch);
  };

  private logout = (): void => {
    this.authenticationResolverService.logout({ ssoLogoutIfEnabled: false });
  };
}
